import httpClient from "../http/http-client";
import { IBackupCodesResponse, IMfaStatus, IOrganisationMfa, IPartnerMfa, ITotpSetupResponse } from './mfa.model';

// Self-service two-factor management plus the admin lockout reset. Mirrors the
// UserAuthService shape (one thin method per endpoint).
export default class MfaService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getStatus(): Promise<IMfaStatus> {
    return this.http.get('user/mfa')
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }

  async setupTotp(): Promise<ITotpSetupResponse> {
    return this.http.post('user/mfa/totp/setup', {})
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }

  async confirmTotp(code: string): Promise<IBackupCodesResponse> {
    return this.http.post('user/mfa/totp/confirm', { code })
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }

  async disableTotp(): Promise<any> {
    return this.http.post('user/mfa/totp/disable', {})
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }

  async enableEmail(): Promise<any> {
    return this.http.post('user/mfa/email/enable', {})
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }

  async disableEmail(): Promise<any> {
    return this.http.post('user/mfa/email/disable', {})
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }

  async regenerateBackupCodes(): Promise<IBackupCodesResponse> {
    return this.http.post('user/mfa/backup-codes/regenerate', {})
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }

  // Admin action: reset another user's MFA after a lockout (same organisation).
  async adminReset(userId: string): Promise<any> {
    return this.http.post('user/mfa/reset', { userId })
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }

  // --- Organisation-wide (admin) ---

  async getOrganisationMfa(): Promise<IOrganisationMfa> {
    return this.http.get('user/mfa/organisation')
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }

  async setOrganisationEnforcement(enabled: boolean): Promise<any> {
    return this.http.post('user/mfa/organisation/enforce', { enabled })
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }

  // Downgrade a user's authenticator app back to email (same organisation).
  async setUserToEmail(userId: string): Promise<any> {
    return this.http.post('user/mfa/set-to-email', { userId })
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }

  // --- Partner (cross-organisation) ---

  async getPartnerMfa(): Promise<IPartnerMfa> {
    return this.http.get('partner/mfa')
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }

  async setPartnerClientEnforcement(organisationId: string, enabled: boolean): Promise<any> {
    return this.http.post('partner/mfa/enforce', { organisationId, enabled })
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }

  async partnerSetUserToEmail(userId: string): Promise<any> {
    return this.http.post('partner/mfa/set-to-email', { userId })
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; })
  }
}
